module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zigbee-not-found"
  }, [_vm._m(0), _vm._v(" "), _c('h5', [_vm._v("已添加主机")]), _vm._v(" "), _c('ul', [_c('li', [_c('hub', {
    attrs: {
      "name": "ZigBee Mini网关",
      "id": "5C:FF:FF:E2:00:86"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "next-btn2"
  }, [_c('button', {
    staticClass: "btn-square-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addZigBeeDeviceClick
    }
  }, [_vm._v("添加其他ZigBee设备")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zigbee-not-found-desc"
  }, [_c('i', {
    staticClass: "iconfont icon-not-found"
  }), _vm._v(" "), _c('h6', {
    staticClass: "zigbee-not-found-desc-header"
  }, [_vm._v("未找到可添加主机")]), _vm._v(" "), _c('ul', {
    staticClass: "zigbee-not-found-desc-notice"
  }, [_c('li', [_vm._v("1.请确认主机已接通电源；")]), _vm._v(" "), _c('li', [_vm._v("2.请确认主机与手机连接到相同的路由器。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ccab2a9"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/zigbee/Hub_listNotFound.vue
// module id = 911
// module chunks = 1